import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/ContextFunctions";
import {
  ChangeStatusSourceApi,
  GetSourecDataList,
} from "../../../services/SourceApi/SourceApi";
import { FormControlLabel, FormGroup, Tooltip } from "@mui/material";
import Android12Switch from "../../../components/common/AndroidSwitch";
import NoResultFoundModel from "../../../components/common/NoDataFound";
import PaginationComponent from "../../../components/common/PaginationModal";
// import AddUpdateSourceModal from "./AddUpdateSourceModal";
import ActiveDeactiveStatusModal from "../../../components/common/ActiveDeactiveStatusModal";
import SuccessModal from "../../../components/common/SuccessModal";
import dayjs from "dayjs";
import UserDefaultAccess from "./UserDefaultAccess";
import { ChangeRoleTypeStatus, GetRoleTypeList } from "../../../services/RoleType/RoleTypeApi";
import AddNewRoleModal from "./AddNewRoleModal";

const UserRoleList = () => {
  const [Tabs, stTabs] = useState(["User Role"]);
  const [activeTab, setActiveTab] = useState("User Role");

  const [searchKeyword, setSearchKeyword] = useState(null);
  const [totalRecords, setTotalRecords] = useState(-1);
  const [totalCount, setTotalCount] = useState(null);
  const [isAddUpdateActionDone, setIsAddUpdateActionDone] = useState(false);
  const [showDefaultAccessModal, setShowDefaultAccessModal] = useState(false);
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [visiblePasswords, setVisiblePasswords] = useState({});
  // const [toDate, setToDate] = useState(dayjs().add(0, 'day'));
  // const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [sourceListData, setSourceListData] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState();
  const [actionMassage, setActionMassage] = useState(null);
  const [sortDirectionValue, setSortDirectionValue] = useState(null);
  const [sortDirectionName, setSortDirectionName] = useState(null);
  // const [sortDirection, setSortDirection] = useState(false);
  // const [modelAction, setModelAction] = useState({});
  // const [errorMessage, setErrorMessage] = useState();
  const [showStatusModal, setShowStatusModal] = useState();
  const { authDetails, isAccessible } = useContext(AuthContext);
  const [actionMsg, setActionMsg] = useState("");
  const [showAddRoleModal, setShowAddRoleModel] = useState(false);
  const [modelRequestData, setModelRequestData] = useState({
    Action: null,
    sourceKeyID: null,
  });
  useEffect(() => {
    SourceDataList(1, null, null, null, null, null);
    // SourceDataList();
  }, []);

  useEffect(() => {
    // debugger
    if (isAddUpdateActionDone) {
      // SourceDataList();
      SourceDataList(currentPage, null, toDate, fromDate, null, null);
    }
    setIsAddUpdateActionDone(false);
  }, [isAddUpdateActionDone]);

  const SourceDataList = async (
    pagenumber,
    searchKeywordValue,
    toDate,
    fromDate,
    sortingType,
    sortValueName
  ) => {
    //
    try {
      const response = await GetRoleTypeList({
        pageNo: pagenumber - 1,
        pageSize: pageSize,
        sortingDirection: sortingType, //OR ASC null
        sortingColumnName: sortValueName, //OR null
        searchKeyword:
          searchKeywordValue === undefined || searchKeywordValue === null
            ? searchKeyword
            : searchKeywordValue,
        fromDate: fromDate ? dayjs(fromDate).format("YYYY-MM-DD") : null,
        toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : null,
      });

      if (response) {
        console.log(response);
        if (response?.data?.statusCode === 200) {
          // setLoader(false);
          if (response?.data?.responseData?.data) {
            const SourceList = response.data.responseData.data;
            const totalCount = response.data.totalCount;

            setTotalCount(totalCount);
            setTotalPages(Math.ceil(totalCount / pageSize));
            setSourceListData(SourceList);
            setTotalRecords(SourceList.length);
          }
        } else {
          console.error(response?.data?.errorMessage);
          // setLoader(false);
        }
      }

      // console.log('response', response);
    } catch (error) {
      console.log(error);
    }
  };

  const ChangeApiDoneSource = async (roleTypeID, userKeyID) => {

    if (
      roleTypeID === undefined ||
      roleTypeID === null ||
      roleTypeID === ""
    ) {
      return;
    }

    if (userKeyID === undefined || userKeyID === null || userKeyID === "") {
      return;
    }

    try {
      const data = await ChangeRoleTypeStatus(userKeyID, roleTypeID);
      if (data?.data?.statusCode === 200) {
        // setLoader(false);
        setActionMsg("Status changed successfully");
        setShowSuccessModal(true);
        setIsAddUpdateActionDone(true);
        setShowStatusModal(false);
      } else {
        console.error("Error fetching data: ", data?.data?.statusCode);
      }
    } catch (error) {
      console.error("Error in GetAppointmentModalData: ", error);
    }
  };

  const UserDefaultAccessBtn = () => {
    // setModelRequestData((prevObj) => ({
    //   ...prevObj,
    //   Action: null,
    //   sourceKeyID: null,
    // }));
    // console.log('We came here');
    setShowDefaultAccessModal(true);
  };
  const handleTabSelect = (key) => {
    setCurrentPage(1);
    setTotalRecords(-1);
    setSourceListData([]);
    if (key === "User Role") {
      setActiveTab("User Role");
      SourceDataList(1, null, null, null, null, null);
    }
  };

  const SourceUpdateBtnClicked = (value) => {
    // setModelRequestData({
    //   ...modelRequestData,
    //   Action: 'Update',
    //   sourceKeyID: value.sourceKeyID
    // });
    setModelRequestData((prevObj) => ({
      ...prevObj,
      Action: "Update",
      sourceKeyID: value.sourceKeyID,
    }));
    setShowDefaultAccessModal(true);
  };
  const handleSearch = (e) => {
    let searchKeywordValue = e.target.value;

    if (searchKeywordValue?.startsWith(" ")) {
      searchKeywordValue = searchKeywordValue?.trimStart(); // Remove leading space
    }
    setSearchKeyword(searchKeywordValue);
    setCurrentPage(1);
    SourceDataList(1, searchKeywordValue, toDate, fromDate, null, null);
  };

  const handleFromDateChange = (newValue) => {
    // const today = dayjs(); // Get today's date
    if (dayjs(newValue).isValid()) {
      const newFromDate = dayjs(newValue);
      setFromDate(newFromDate);
      // EmployeeDataList(searchKeyword);
      SourceDataList(1, null, toDate, newFromDate, null, null);
    }
  };

  const handleToDateChange = (newValue) => {
    // const today = dayjs(); // Get today's date

    if (dayjs(newValue).isValid()) {
      const newToDate = dayjs(newValue);
      setToDate(newToDate);
      // EmployeeDataList(searchKeyword);
      SourceDataList(1, null, newToDate, fromDate, null, null);
    }
  };

  const handlePageChange = (pagenumber) => {
    setCurrentPage(pagenumber);
    setTotalRecords(-1);
    SourceDataList(
      pagenumber,
      null,
      toDate,
      fromDate,
      sortDirectionValue,
      sortDirectionName
    );
  };
  const clearDate = () => {
    setToDate(null);
    setFromDate(null);
    SourceDataList(1, null, null, null, null, null, null);
  };

  const handleSort = (sortDirectionValue, sortDirectionName) => {

    if (sortDirectionName === "roleTypeName") {
      setCurrentPage(1);
      SourceDataList(
        1,
        null,
        toDate,
        fromDate,
        sortDirectionValue,
        sortDirectionName
      );
      setSortDirectionValue(sortDirectionValue);
      setSortDirectionName(sortDirectionName);
    }
  };

  const OpenChangeModal = (value) => {
    // setModelRequestData({
    //   ...modelRequestData,
    //   Action: 'SourceStatus',
    //   sourceKeyID: value.sourceKeyID
    // });
    setModelRequestData((prevObj) => ({
      ...prevObj,
      Action: "RoleStatus",
      roleTypeID: value.roleTypeID,
    }));
    // console.log('We came here');
    setShowStatusModal(true);
  };

  const ChangeStatusData = () => {
    ChangeApiDoneSource(modelRequestData.roleTypeID, authDetails.userKeyID);
  };

  const AddRoleBtnClicked = () => {
    setModelRequestData(((prev) => ({ ...prev, Action: null, roleTypeID: null })))
    setShowAddRoleModel(true)
  }
  const updateRoleBtnClicked = (value) => {
    setModelRequestData(((prev) => ({ ...prev, Action: 'update', roleTypeID: value?.roleTypeID })))
    setShowAddRoleModel(true)
  }

  const closeAll = () => {
    setShowDefaultAccessModal(false);
    setShowAddRoleModel(false)
    setShowSuccessModal(false);
  };
  return (
    <>
      <div className="mx-auto rep-width">
        <div className="h-full bg-white shadow rounded-lg flex flex-col">
          <div className="p-2 border-b flex flex-wrap items-center justify-between space-x-4">
            {/* Search Bar */}
            <div className="relative w-full sm:w-64 md:w-68">
              <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400"></span>
              <input
                type="text"
                value={searchKeyword}
                onChange={(e) => handleSearch(e)}
                className="bg-white border border-gray-300 text-gray-700 text-sm rounded-md focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 block w-full pl-4 py-1.5"
                placeholder="Search..."
              />
            </div>

            {/* Date Pickers */}
            <div className="flex items-center gap-4 w-full sm:w-auto">
              {/* <DatePicker
                isClearable={false}
                placeholderText="Select From Date"
                className="px-2 py-1.5 text-sm w-40 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                label="From Date"
                value={fromDate?.toDate()}
                onChange={handleFromDateChange}
                renderInput={(params) => (
                  <input
                    {...params.inputProps}
                    className="date-picker-input-field w-full rounded-md px-2 py-1.5"
                  />
                )}
                format="dd/MM/yyyy"
                popperPlacement="bottom-start"
                maxDate={new Date()}
              />

              <DatePicker
                isClearable
                className="px-2 py-1.5 text-sm w-40 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                label="To Date"
                value={toDate?.toDate()}
                // minDate={fromDate?.toDate()}
                onChange={handleToDateChange}
                renderInput={(params) => (
                  <input
                    {...params.inputProps}
                    className="date-picker-input-field w-full rounded-md px-2 py-1.5"
                  />
                )}
                format="dd/MM/yyyy"
                popperPlacement="bottom-start"
                maxDate={new Date()}
              /> */}
            </div>
            {/* </div> */}
            <div className="flex items-center">
              {/* <div className="relative" style={{ minWidth: "96px" }}>
                {(fromDate || toDate) && (
                  <Tooltip title="Clear Dates">
                    <button
                      id="clearBtn"
                      type="button"
                      onClick={clearDate}
                      className="btn btn-primary actionBtn px-2 py-1.5 ml-3 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                      Clear
                    </button>
                  </Tooltip>
                )}
              </div> */}
            </div>

            {/* Salesman Select */}

            <div className="w-full md:w-auto mb-2 md:mb-0 z-10"> </div>

            {/* Add Lead Button */}
            <div className="w-full md:w-auto  flex justify-end mt-2 md:mt-0">
              {isAccessible?.RoleType?.canInsert && (
                <Tooltip title="Add New Role">
                  <button
                    id="addBtn"
                    type="button"
                    onClick={() => AddRoleBtnClicked()}
                    className="mx-2 bg-blue-500 text-white rounded-md px-3 py-1 text-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                  >
                    Add Role
                  </button>
                </Tooltip>
              )}
              {isAccessible?.SetDefaultAccess?.canUpdate && (
                <Tooltip title="Set Default Access">
                  <button
                    id="addBtn"
                    type="button"
                    onClick={() => UserDefaultAccessBtn()}
                    className="bg-blue-500 text-white rounded-md px-3 py-1 text-sm hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                  >
                    Set Default Access
                  </button>
                </Tooltip>
              )}

            </div>
          </div>
          {/* Tabs Name */}
          <div
            className="border-b p-4"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 15px",
            }}
          >
            <div>
              {Tabs.map((tab) => (
                <button
                  key={tab}
                  className={`px-4 py-2 ${activeTab === tab
                    ? "border-b-2 border-blue-500 text-blue-600"
                    : "text-gray-500"
                    }`}
                  onClick={() => {
                    handleTabSelect(tab);
                    setActiveTab(tab);
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>
        {/* </div> */}

        {/* Table Content */}
        <div className="flex flex-col table_wrapper border border-gray-200">
          <div className="flex-1 overflow-y-auto">
            {activeTab === "User Role" && (
              <>
                <table className="w-full border-collapse border border-gray-200 text-sm table-auto">
                  <thead>
                    <tr className="sticky top-0 bg-white z-10">
                      <th
                        className="p-1 border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap"
                        style={{ width: "10%" }}
                      >
                        Sr No.
                      </th>

                      <th
                        className="p-1 border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap"
                        style={{ width: "60%" }}
                      >
                        User Role
                        {sortDirectionValue === "DESC" && (
                          <i
                            onClick={() => handleSort("ASC", "roleTypeName")}
                            class="fa fa-sort"
                            style={{ cursor: "pointer", marginLeft: "5px" }}
                          ></i>
                        )}
                        {(sortDirectionValue === "ASC" ||
                          sortDirectionValue === null) && (
                            <i
                              onClick={() =>
                                handleSort(
                                  "DESC",
                                  "roleTypeName"
                                )
                              }
                              class="fa fa-sort"
                              style={{ cursor: "pointer", marginLeft: "5px" }}
                            ></i>
                          )}
                      </th>
                      {isAccessible?.RoleType?.canUpdate && (
                        <>
                          <th
                            className="p-1 border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap"
                            style={{ width: "20%" }}
                          >
                            Status
                          </th>

                          <th
                            className="p-1 border-b border-slate-200 bg-slate-50 text-center whitespace-nowrap "
                            style={{ width: "10%" }}
                          >
                            Action
                          </th>
                        </>

                      )}

                    </tr>
                  </thead>
                  <tbody>
                    {sourceListData?.map((value, index) => (
                      <tr class="hover:bg-slate-50 border-b border-slate-200 text-center">
                        <td className="p-1 whitespace-nowrap text-left pl-4">
                          {(currentPage - 1) * pageSize + index + 1}
                        </td>

                        {/* <td className="p-1 whitespace-nowrap text-left pl-1">
                        {value.sourceName}
                      </td> */}
                        <td className="p-1 whitespace-nowrap text-left pl-4">
                          {value.roleTypeName?.length > 30 ? (
                            <Tooltip
                              title={value.roleTypeName}
                            >{`${value.roleTypeName?.substring(
                              0,
                              30
                            )}...`}</Tooltip>
                          ) : (
                            <>{value.roleTypeName}</>
                          )}
                        </td>
                        {isAccessible?.RoleType?.canUpdate && (
                          <>
                            <td className="text-center align-middle">
                              <div className="flex items-center gap-3 justify-center">
                                {value.status === true ? "Enable" : "Disable"}
                                <Tooltip
                                  title={
                                    value.status === true ? "Enable" : "Disable"
                                  }
                                >
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Android12Switch
                                          style={{ padding: "8px" }}
                                          onClick={() => OpenChangeModal(value)}
                                          checked={value.status}
                                          data-bs-toggle="modal"
                                          data-bs-target="#ConfirmModel"
                                          disabled={(value?.roleTypeID > 0 && value?.roleTypeID <= 6)}
                                        />
                                      }
                                    />
                                  </FormGroup>
                                </Tooltip>
                              </div>
                            </td>

                            <td className="p-1 py-1 w-5  actionColSticky">
                              <div className="flex items-center gap-1 text-center justify-center">
                                {value?.roleTypeID > 0 && value?.roleTypeID <= 6 ? (
                                  '-'
                                ) : <Tooltip title="Update Role" arrow>
                                  <button

                                    onClick={() => updateRoleBtnClicked(value)}
                                    style={{
                                      fontSize: "12px",
                                      padding: "5px 10px",
                                    }}
                                    type="button"
                                    className="bg-blue-500 hover:bg-blue-600 text-white rounded-md px-1.5 py-1 text-xs shadow-sm transition-all duration-150 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-400 whitespace-nowrap"
                                  >
                                    <i className="fa-solid fa-pen-to-square"></i>
                                  </button>
                                </Tooltip>}

                              </div>
                            </td>
                          </>
                        )}

                      </tr>
                    ))}
                  </tbody>
                </table>
                {totalRecords <= 0 && (
                  <NoResultFoundModel totalRecords={totalRecords} />
                )}
                {totalCount > pageSize && (
                  <PaginationComponent
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                )}
              </>
            )}
          </div>
        </div >
      </div >
      {showDefaultAccessModal && (
        <UserDefaultAccess
          show={showDefaultAccessModal}
          onHide={() => setShowDefaultAccessModal(false)}
          //   modelRequestData={modelRequestData}
          setShowSuccessModal={setShowSuccessModal}
          setIsAddUpdateActionDone={setIsAddUpdateActionDone}
        />
      )}

      {
        showStatusModal && (
          <ActiveDeactiveStatusModal
            show={showStatusModal}
            onHide={() => setShowStatusModal(false)}
            modelRequestData={modelRequestData}
            setIsAddUpdateActionDone={setIsAddUpdateActionDone}
            UpdatedStatus={ChangeStatusData}
          />
        )
      }
      {
        showSuccessModal && (
          <SuccessModal
            isOpen={showSuccessModal}
            onClose={closeAll}
            actionMassage={actionMsg}
          />
        )
      }
      {
        showAddRoleModal && (
          <AddNewRoleModal
            show={showAddRoleModal}
            onHide={closeAll}
            modelRequestData={modelRequestData}
            setIsAddUpdateActionDone={setIsAddUpdateActionDone}

          />
        )
      }
    </>
  );
};

export default UserRoleList;
